module.exports = __webpack_public_path__ + "static/media/Montana2927.b032d452.jpg";